import {Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { IGlobalSettings } from '@irb/irb-settings/irb-settings.model';
import { IrbAppEvents, IrbClientsEvents, IrbModelsEvents } from '@irb-common/events';
import { IrbModelsService } from '@irb/irb-models/irb-models.service';
import { ISecurityCustomCategories } from '@irb/irb-models/irb-models.model';
import { UtilityService } from '@irb-common/services/utility.service';
import { ImportSecurityCategoryNoninventoriedGridLayoutService } from './import-security-category-noninventoried.grid-layout.service';
import { ImportSecurityCategoryUnrecognizedGridLayoutService } from './import-security-category-unrecognized.grid-layout.service';
import { ImportSecurityCategoryInventoriedGridLayoutService } from './import-security-category-inventoried.grid-layout.service';
import { SecurityMasterService } from '../security-master/security-master.service';
import { IAlertDialogData } from '@irb/app.model';
import { IDropdownItem } from '@irb/irb-common/models/dropdown.model';
import { IrbEditorsService } from '../../irb-editors/irb-editors.service'//IREBAL-26684

@Component({ standalone: false,
  selector: 'irb-import-security-category-securities-dialog',
  templateUrl: './import-security-category-securities-dialog.component.html',
  styleUrls: ['./import-security-category-securities-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportSecurityCategorySecuritiesDialogComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  globalSettings: IGlobalSettings;
  totalSelectCount: number = 0;
  isSelectedAll: boolean=true;
  totalUpdatedCount: number = 0; 
  totalSecutitiesCount: number = this.data.Inventoried?.count + this.data.NonInventoried?.count + this.data.unRecognized?.count;
  inValidSymbolCnt: number = this.data.inValidSymbolCnt ? this.data.inValidSymbolCnt : 0; 
  securitiesCustomCategories: Array<IDropdownItem> = [];
  securityTypes: Array<IDropdownItem> = [  
    {value:'NONE', name:'Select'}, 
    {value:'GROUP', name:'Group'},
    {value:'OTHER', name:'Other'},
    {value:'SMA', name:'SMA'},
    {value:'EXTERNAL', name:'External'}
  ];
  summaryValue: string="";
  detailsMsg: string="";
  isValidToContinue: boolean = true;
  parent_noninventoried: any = {
    enableDisableBtns: (() => { this.updateSelectCount(); }).bind(this),
    totalRecordsFromServer: 0,
    uniqueField: "securitySymbol",
    deselectedFromSelectAllRecords: [],
    securityTypes: this.securityTypes,
    securitiesCustomCategories: this.securitiesCustomCategories
  };
  grid_noninventoried: any;
  gridOptions_noninventoried: any;

  parent_inventoried: any = {
    enableDisableBtns: (() => { this.updateSelectCount(); }).bind(this),
    totalRecordsFromServer: 0,
    uniqueField: "securitySymbol"
  };
  grid_inventoried: any;
  gridOptions_inventoried: any;

  parent_unrecognized: any = {
    enableDisableBtns: (() => { this.updateSelectCount(); }).bind(this),
    totalRecordsFromServer: 0,
    uniqueField: "securitySymbol",
    deselectedFromSelectAllRecords: [],
    securityTypes: this.securityTypes,
    securitiesCustomCategories: this.securitiesCustomCategories,
    isValidToContinue: true
  };
  grid_unrecognized: any;
  gridOptions_unrecognized: any;
  updateStatusCount = 0;
  progressTimer: any;
  isUiTest = false;
  frameworkComponents_noninventoried: any;
  frameworkComponents_inventoried: any;
  frameworkComponents_unrecognized: any;

  constructor(
    public dialogRef: MatDialogRef<ImportSecurityCategorySecuritiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls_inventoried: ImportSecurityCategoryInventoriedGridLayoutService,
    private gls_noninventoried: ImportSecurityCategoryNoninventoriedGridLayoutService,
    private gls_unrecognized: ImportSecurityCategoryUnrecognizedGridLayoutService,    
    private iss: IrbSettingsService,
    private ms: IrbModelsService,
    private util: UtilityService,
    public securityMasterService:SecurityMasterService,
    public irbEditorsService: IrbEditorsService //IREBAL-26684
  ) {
    this.totalSecutitiesCount = this.data.Inventoried?.count + this.data.NonInventoried?.count + this.data.unRecognized?.count;

    this.parent_noninventoried.totalRecordsFromServer = this.data.NonInventoried?.data.length;
    this.parent_inventoried.totalRecordsFromServer = this.data.Inventoried?.data.length;
    this.parent_unrecognized.totalRecordsFromServer = this.data.unRecognized?.data.length;

    this.ms.getSecuritiesCustomCategories().pipe(takeUntil(this.destroyed$)).subscribe((data: ISecurityCustomCategories) => {
      for (const item of data.items) {
        this.securitiesCustomCategories.push({ value: String(item.custCatId), name: item.custCatName });
      }

      this.securitiesCustomCategories = this.util.sortByKey(this.securitiesCustomCategories, "name", "asc");
      this.parent_noninventoried.securitiesCustomCategories = this.securitiesCustomCategories;
      this.parent_unrecognized.securitiesCustomCategories = this.securitiesCustomCategories;

      this.gridOptions_noninventoried = {
        columnDefs: this.gls_noninventoried.getColumnDefs(this.parent_noninventoried),        
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities found.</span>",
        context: { componentParent: this },
        rowSelection: 'multiple',
        suppressHorizontalScroll: true
      };
      
      this.frameworkComponents_noninventoried = this.gls_noninventoried.getFrameworkComponents();

      this.gridOptions_inventoried = {
        columnDefs: this.gls_inventoried.getColumnDefs(this.parent_inventoried),        
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities found.</span>",
        context: { componentParent: this },
        rowSelection: 'multiple',
        suppressHorizontalScroll: true
      };
      
      this.frameworkComponents_inventoried = this.gls_inventoried.getFrameworkComponents();
  
      this.gridOptions_unrecognized = {
        columnDefs: this.gls_unrecognized.getColumnDefs(this.parent_unrecognized),        
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities found.</span>",
        context: { componentParent: this },
        rowSelection: 'multiple',
        suppressHorizontalScroll: true
      };
      
      this.frameworkComponents_unrecognized = this.gls_unrecognized.getFrameworkComponents();
    });
  }
  

  ngOnInit(): void {    
    
  }

  close() {
    this.dialogRef.close();
  }

  onNoninventoriedGridReady(params: any) {
    this.grid_noninventoried = params;
    this.setCCColumnHeader(this.grid_noninventoried);
    this.updateSelectCount();
  }

  onInventoriedGridReady(params: any) {
    this.grid_inventoried = params;
    this.setCCColumnHeader(this.grid_inventoried);
  }

  onUnRecognizedGridReady(params: any) {
    this.grid_unrecognized = params;
    this.setCCColumnHeader(this.grid_unrecognized);
    this.updateSelectCount();
  }

  setCCColumnHeader(g: any) {
    const f = () => {
      if (this.globalSettings.securityCustAttrAbbr) {
        g.api.getColumnDef("custCategoryCol").headerName = this.globalSettings.securityCustAttrAbbr;
        g.api.refreshHeader();
      }
    };

    if(!this.globalSettings) {
      this.iss.getGlobalSettings().subscribe((data) => {
        this.globalSettings = data as IGlobalSettings;
        f();
      }); 
    } else {
      f();
    }
  }

  updateSelectCount() {
    this.totalSelectCount = (this.grid_noninventoried) ? this.grid_noninventoried.api.getSelectedRows().length : 0;
    this.totalSelectCount += (this.grid_unrecognized) ? this.grid_unrecognized.api.getSelectedRows().length : 0;

  }

  refreshRequired(){
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
        dTitle: 'Refresh Required',
        dProceedBtnLabel: 'Refresh',
        msg: "You are attempting to create or update securities that was just modified by someone else. To see the updated securities, you need to refresh the page.",
        onProceed: () => {this.as.fireEvent(IrbAppEvents.GRID_REFRESH);}
    } as IAlertDialogData);
  }

  completeImport() {

    this.data.NonInventoried.dataList = (this.grid_noninventoried) ? this.grid_noninventoried.api.getSelectedRows() : [];
    this.data.unRecognized.dataList = (this.grid_unrecognized) ? this.grid_unrecognized.api.getSelectedRows() : [];
    
    if(this.data.unRecognized.dataList && this.data.unRecognized.dataList.length > 0){
      for(let i=0;i<this.data.unRecognized.dataList.length ;i++){ 
        if(this.data.unRecognized.dataList[i].securityType === null || this.data.unRecognized.dataList[i].securityType === "" || this.data.unRecognized.dataList[i].securityType === "NONE"){
          this.isValidToContinue = false;
          this.parent_unrecognized.isValidToContinue = false;
          this.grid_unrecognized.api.redrawRows();
          return;
        }
      }
    }

    let savingParams: Array<any> = [];

    if (this.data.oerwriteData && this.data.oerwriteData.length > 0 ) {
      savingParams = savingParams.concat(this.data.Inventoried.data);
    }

    if (this.data.NonInventoried && this.data.NonInventoried.dataList && this.data.NonInventoried.dataList.length !== 0 ) {
      savingParams = savingParams.concat(this.data.NonInventoried.dataList);
    }

    if (this.data.unRecognized && this.data.unRecognized.dataList && this.data.unRecognized.dataList.length !== 0 ) {
      savingParams = savingParams.concat(this.data.unRecognized.dataList);
    }

    if(this.data.isCreateSecurites){
      this.summaryValue = " New Securities";
      this.detailsMsg = " securities added.";
    }else if(this.data.isImportEquivalents){
      this.summaryValue = " Import Equivalents";
      this.detailsMsg = " securities imported/updated.";
    }else if(this.data.isImportSecurityCategory){
      this.summaryValue = " Import Security Category";
      this.detailsMsg = " securities imported/updated.";
    }

    let isUpdateEquivalents: boolean = false;
    if (this.data.validRecords && this.data.validRecords.length > 0) {
      isUpdateEquivalents = true;
    }

    if (savingParams.length !== 0) {
      isUpdateEquivalents = false;
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
      this.securityMasterService.addNewSecurityProfilesAsync(savingParams).subscribe((response: any) => {
        //this.updateNewSecurityProfilesFinish(response);
        this.updateStatusCount = 0;
        if(this.progressTimer) clearTimeout(this.progressTimer);
        this.updateStatusCount = 0;
        if (response.responseUtilityMap)
          this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
      }, () => {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      });
    } else
      this.close();

    if (isUpdateEquivalents) {
      this.updateEquivalents();
    }
  }

  updateNewSecurityProfilesFinish(response: any) {
    if (response.responseStatus === "SUCCESS") {

      if (this.data.validRecords && this.data.validRecords.length > 0) {
        this.updateEquivalents();
      } else {
        if (response.responseData.length === 1 ) {
          if(this.data.isCreateSecurites){
            this.detailsMsg = " security added.";
          } else if(this.data.isImportEquivalents){
            this.detailsMsg = " security imported/updated.";
          } else if(this.data.isImportSecurityCategory){
            this.detailsMsg = " security imported/updated.";
          }
        }
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: this.summaryValue,
          detail: response.responseData.length + this.detailsMsg
        });
      }
      this.fireIntegrationEvent(response);
      let noRefresh = false;
      if (this.data) {
        let eventData = JSON.parse(JSON.stringify(this.data));
        noRefresh = eventData.noRefresh || false;
      }
      if (!noRefresh)
        this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    } else if (response.responseStatus === "STALEDATAEXCEPTION") {
      this.refreshRequired();
    }else {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'error',
        summary: this.summaryValue,
        detail: " An error occurred processing your request."
      });
    }
  }

  private updateEquivalents() {
    //IREBAL-26684
    this.securityMasterService.updateEquivalentsAsync(this.data.validRecords).subscribe((data: any) => {
      if (this.progressTimer) clearTimeout(this.progressTimer);

      if(data.responseStatus=== "SUCCESS") {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
            this.updateEquivalentsStatusCheckIntervalStart(data.responseUtilityMap.statusId);
      } else if (data.responseStatus === "STALEDATAEXCEPTION") {
        this.refreshRequired();
      }else{
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'Import Equivalents',
          detail: " An error occurred processing your request."
        });
        this.close();
      }
    });
  }

  //IREBAL-26684
  updateEquivalentsStatusCheckIntervalStart(statusId: any) {
    this.irbEditorsService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      const response = statusResponse?.responseData;
      const reqStatus = response?.reqStatus?.trim().toUpperCase();

      if (reqStatus === 'FAILED') {
        this.actionStatusCheckFailed();
      }

      if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
        this.updateProgressBarStatus(statusId);
      }

      if (reqStatus === 'COMPLETED') {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: 'Import Equivalents',
          detail: statusResponse.responseData.successRecCount + " security(ies) imported/updated. "
        });
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if (this.progressTimer) clearTimeout(this.progressTimer);
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  updateProgressBarStatus(statusId: any) {
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
      timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
      this.updateEquivalentsStatusCheckIntervalStart(statusId);
    }, timeout);
  }

  updateRow(params: any) {
    if (this.grid_unrecognized && this.grid_unrecognized.api) {
      this.grid_unrecognized.api.redrawRows({rowNodes: [params.node]});
    }
    if (this.grid_noninventoried && this.grid_noninventoried.api) {
      this.grid_noninventoried.api.redrawRows({rowNodes: [params.node]});
    }
  }  

  private fireIntegrationEvent(response: any) {
    let eventData = JSON.parse(JSON.stringify(this.data)); // create a deep copy
    // delete un-needed if exists
    delete eventData.invalidRecords;
    delete eventData.NonInventoried;
    delete eventData.Inventoried;
    delete eventData.CSVImportDetails;
    delete eventData.errorSymbols;
    delete eventData.unRecognized;
    delete eventData.unRecogCustCategory;
    delete eventData.oerwriteData;

    if (response && response.responseData) {
      if (response.responseData.length !== 0) {
        let newItemsForDD: any = [];
        response.responseData.forEach((sec: any) => {
          newItemsForDD.push({name: sec.securitySymbol, value: sec.securityId})
        });
        eventData.newItemsForDD = newItemsForDD;
      }
    }
    eventData.securities = response;
    this.as.fireEvent(IrbModelsEvents.SAVE_CREATE_NEW_SECURITY, eventData);
  }


  actionStatusCheckIntervalStart(statusId: any) {
    this.securityMasterService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {

        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.requestStatus) {
          reqStatus = statusResponse.responseUtilityMap.requestStatus.trim().toUpperCase();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
          if (this.isUiTest)
            timeout = 0;
          this.updateStatusCount++;
          this.progressTimer = setTimeout(() => {
            this.actionStatusCheckIntervalStart(statusId);
          }, timeout);
        }

        if (reqStatus === 'COMPLETED') {
          if(this.progressTimer) clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          const responseData = JSON.parse(statusResponse.responseData);
          this.updateNewSecurityProfilesFinish(responseData);
          this.close();
        }

        if (reqStatus === 'STALEDATAEXCEPTION') {
          this.close();
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if (this.progressTimer) clearTimeout(this.progressTimer);
          this.refreshRequired();
        }

        if (reqStatus === 'FAILED') {
          this.actionStatusCheckFailed();
        }
      } else {
        this.actionStatusCheckFailed();
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if(this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if(this.progressTimer) clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'error',
      summary: this.summaryValue,
      detail: " An error occurred processing your request."
    });
  }

  ngOnDestroy() {
    if(this.progressTimer) clearTimeout(this.progressTimer);
  }
}
